"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Days = exports.Average = exports.Budget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Row_1 = require("./Row");
const react_i18next_1 = require("react-i18next");
const NutritionValues_1 = require("./NutritionValues");
const hooks_1 = require("../../shared/hooks");
const Budget = ({ budget, unit }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Row_1.Row, { title: t(`nutrition.weekOverview.budgetTraining${fixMobile(isMobile)}`), children: (0, jsx_runtime_1.jsx)(NutritionValues_1.NutritionValues, { facts: budget.trainingDays, unit: unit }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Row_1.Row, { title: t(`nutrition.weekOverview.budgetNonTraining${fixMobile(isMobile)}`), children: (0, jsx_runtime_1.jsx)(NutritionValues_1.NutritionValues, { facts: budget.nonTrainingDays, unit: unit }, void 0) }, void 0)] }, void 0));
};
exports.Budget = Budget;
const fixMobile = (isMobile) => (isMobile ? "Mobile" : "");
const mapFacts = (aveFactMap) => {
    const map = new Map();
    Array.from(aveFactMap.entries()).forEach(([key, value]) => {
        map.set(key, value.difference);
    });
    return map;
};
const mapToObject = (aveFactMap) => {
    const factObj = {
        calories: null,
        carbs: null,
        protein: null,
        fats: null,
        fibers: null
    };
    Array.from(aveFactMap.entries()).forEach(([key, value]) => {
        factObj[key] = value;
    });
    return factObj;
};
const Average = ({ average, unit, hasCalorieBudgetInfo }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Row_1.Row, { title: t(`nutrition.weekOverview.averageTraining${fixMobile(isMobile)}`), children: (0, jsx_runtime_1.jsx)(NutritionValues_1.FactWithColor, { facts: mapFacts(average.trainingDays), unit: unit, calorieBudget: mapToObject(average.trainingDays), hasCalorieBudgetInfo: hasCalorieBudgetInfo }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Row_1.Row, { title: t(`nutrition.weekOverview.averageNonTraining${fixMobile(isMobile)}`), children: (0, jsx_runtime_1.jsx)(NutritionValues_1.FactWithColor, { facts: mapFacts(average.nonTrainingDays), unit: unit, calorieBudget: mapToObject(average.nonTrainingDays), hasCalorieBudgetInfo: hasCalorieBudgetInfo }, void 0) }, void 0)] }, void 0));
};
exports.Average = Average;
const Days = ({ days, unit }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Row_1.Row, { children: (0, jsx_runtime_1.jsx)(NutritionValues_1.FactsShortNames, { names: t("nutrition.weekOverview.factsShortNames", {
                        returnObjects: true
                    }) }, void 0) }, void 0), Array.from(days.keys()).map((day) => {
                const { calorieBudgetInfo, facts } = days.get(day);
                return ((0, jsx_runtime_1.jsx)(Row_1.Row, { title: isMobile ? day.split("-")[0] : day, children: (0, jsx_runtime_1.jsx)(NutritionValues_1.FactWithColor, { facts: facts, unit: unit, calorieBudget: calorieBudgetInfo, hasCalorieBudgetInfo: !!calorieBudgetInfo }, void 0) }, day));
            })] }, void 0));
};
exports.Days = Days;
//# sourceMappingURL=Elements.js.map